<template>
  <v-row
    no-gutters
    class="px-0"
  >
    <v-col
      cols="12"
      class="px-0"
      :sm="6"
      :md="6"
    >
      <WDatePicker
        :date.sync="startDateValue"
        :label="fromLabel"
        :min="minStartDate || null"
        :max="getMaxEndValue"
        :clear-event="clearStartEvent"
        :disabled="disabled"
        @update:date="setStartDate"
      />
    </v-col>
    <v-col
      cols="12"
      class="px-3"
      :sm="6"
      :md="6"
    >
      <WDatePicker
        :date.sync="endDateValue"
        :label="toLabel"
        :min="getMinEndValue"
        :clear-event="clearEndEvent"
        :disabled="disabled"
        @update:date="setEndDate"
      />
    </v-col>
  </v-row>
</template>

<script>

import WDatePicker from '@/components/common/date-picker/index.vue'

export default {
  name: 'DateRangeSelector',
  components: {
    WDatePicker
  },
  props: {
    fromLabel: {
      type: String
    },
    clearStartEvent: {
      type: String,
      default: null
    },
    clearEndEvent: {
      type: String,
      default: null
    },
    toLabel: {
      type: String
    },
    onDateStartChangeEvent: {
      type: String
    },
    onDateEndChangeEvent: {
      type: String
    },
    remoteStartDate: {
      type: String
    },
    remoteEndDate: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    startDateValue: null,
    endDateValue: null,
    minStartDate: null,
    maxDate: null,
  }),
  computed: {
    getMinEndValue () {
      if (!this.startDateValue) {
        return undefined
      }

      return this.startDateValue
    },
    getMaxEndValue () {
      if (!this.endDateValue) {
        return undefined
      }

      return this.endDateValue
    }
  },
  async  created () {
    if (this.remoteStartDate) {
      this.startDateValue = this.remoteStartDate
    }
    if (this.remoteEndDate) {
      this.endDateValue = this.remoteEndDate
    }
    // const startDate = this.$moment().add(1, 'days')
    // this.startDateValue = startDate.format('YYYY-MM-DD')
    // const endDate = this.$moment().add(-7, 'days')
    //
    // this.endDateValue = endDate.format('YYYY-MM-DD')
  },
  methods: {
    setStartDate () {
      this.endDateValue = null
      if (this.onDateStartChangeEvent) {
        this.$emit(this.onDateStartChangeEvent, this.startDateValue)
      }
    },
    setEndDate () {
      if (this.onDateEndChangeEvent) {
        this.$emit(this.onDateEndChangeEvent, this.endDateValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.office-item {
  cursor: pointer;
}
.reportrange-text {
  padding: 11px 10px;
}
.vue-daterange-picker {
  width: 100% !important;
}
</style>
